import { getCustomProps, getNotCustomProps } from '../forms'
import { getData } from '../get-table'
import { HttpService } from '../http.service'

const http = new HttpService()

export interface Account {
  id?: string
  name: string
  code: string
}

export async function getAccounts(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = ''
): Promise<any> {
  // where's
  const where = ['company_id = :companyId']
  if (search) {
    where.push(`CONCAT(name, code) ILIKE '%${search}%'`)
  }
  // order by
  let modifier = []
  dataOrder !== ''
    ? dataOrder[1] === 'code'
      ? (modifier = [
          `ORDER BY (CASE WHEN code ~ '^[0-9]+$' THEN CAST(code AS NUMERIC) ELSE NULL END) ${dataOrder[0]}, code ${dataOrder[0]}`
        ])
      : (modifier = [`order by ${dataOrder[1]} ${dataOrder[0]}`])
    : (modifier = [
        "ORDER BY (CASE WHEN code ~ '^[0-9]+$' THEN CAST(code AS numeric) ELSE NULL END), code"
      ])
  // result
  const response: any = await getData({
    tables: ['pg_ledger_accounts'],
    fields: ['id', 'code', 'name', 'is_inactive', 'updated_at'],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })
  return response
}

export async function getAccount(id: string): Promise<Account> {
  const data = await getData<any>({
    tables: ['pg_ledger_accounts'],
    fields: ['id', 'code', 'name', 'is_inactive', 'custom_fields as custom'],
    where: [`id = '${id}'`],
    options: {
      outputFormat: 'json',
      pagination: { offset: 0, limit: 10 }
    }
  })
  return data[0].results[0]
}

export async function createAccount(data: any): Promise<boolean> {
  const response: any = await http.post('concept/ledger-accounts', {
    ...getNotCustomProps(data),
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateAccount(
  data: Account,
  id: string
): Promise<boolean> {
  const response: any = await http.put('concept/ledger-accounts/' + id, {
    ...getNotCustomProps(data),
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function stateAccount(
  id: string,
  enable: boolean
): Promise<boolean> {
  const response: any = await http.put(`concept/ledger-accounts/${id}/enable`, {
    enable
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function deleteAccount(id: string): Promise<boolean> {
  const response: any = await http.delete('concept/ledger-accounts/' + id)

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function getCompaniesAccountIntegration() {
  const data = await getData<any>({
    tables: ['pg_companies'],
    fields: ['integrations'],
    where: ['id = :companyId'],
    modifier: ['order by id asc']
  })

  return data[0].results[0].integrations.SAP_SERVICE_LAYER
}

export async function resourceSync(): Promise<string> {
  const response: any = await http.post('integration-action', { 
    integrationType: 'sap-service',
    actionType: 'SYNC',
    parameters: {
      entity: 'ledger_accounts'
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

/* Consultar solicitud de reporte */
export async function getIntegrationAction(id: string) {
  const data = await getData<any>({
    tables: ['pg_integration_actions'],
    fields: [
      'integration_actions.errors',
      'process_status.name as status'
    ],
    join: [
      'INNER JOIN process_status ON integration_actions.process_status_id=process_status.id'
    ],
    where: [`integration_actions.id ='${id}'`]
  })

  return data[0].results[0]
}
